const PERMISSION_KEY= "aitools:ai_video_generator";
const PAGE_URL = {
    AI_VIDEO_GENERATOR_PAGE: "/admin/ai-tools/ai-video-generator"
}

export {PERMISSION_KEY, PAGE_URL}

